import React, { useState } from 'react'
import PropTypes from 'prop-types'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import Button from '../../commons/Button/Button'
import Text from '../../commons/Text/Text'
import Form from '../../commons/Form/Form'
import TextFieldFormik from '../../commons/Fields/TextFieldFormik'
import ModalFeedback from '../../commons/ModalFeedback/ModalFeedback'
import styles from './registerAlterEmail.module.scss'

const validate = (values) => {
  const errors = {}

  if (!values.email) {
    errors.email = 'E-mail inválido'
  }

  return errors
}

const initialValues = {
  email: ''
}

const RegisterEmailForm = (props) => {
  const { handleSubmit } = props

  const [showFeedback, setShowFeedback] = useState(false)

  return (
    <>
      <Form
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        validate={validate}
        render={(renderProps) => {
          const { isValid } = renderProps

          return (
            <div className={styles.containerButton}>
              <Button
                type="outlined_dark"
                margin="12px 0 0"
                buttonType="button"
                width="160px"
                onClick={() => history.push(routes.login.path)}
              >
                <Text
                  font="custom"
                  color="gray"
                  variation="dark"
                  size="xs"
                  value="Voltar"
                  bold
                />
              </Button>
              <Button
                type="secondary"
                margin="12px 0 0"
                buttonType="button"
                disabled={!isValid}
                width="160px"
                onClick={() => setShowFeedback(true)}
              >
                <Text
                  font="custom"
                  color="white"
                  size="xs"
                  value="Alterar"
                  bold
                />
              </Button>
            </div>
          )
        }}
      >
        <TextFieldFormik
          name="email"
          validate="email"
          label="Digite seu e-mail"
        />
      </Form>
      <ModalFeedback
        visible={showFeedback}
        closeCallback={() => {
          setShowFeedback(false)
          history.push(routes.registerEmailConfirmed.path)
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Text color="gray" variation="dark" size="lg">
            Reenviamos o e-mail!
          </Text>
          <Text
            font="custom"
            size="xxs"
            color="gray"
            variation="light"
            margin="24px 0px 6px 0px"
          >
            Reenviamos o link de confirmação de cadastro
            {/* para o e-mail */}
          </Text>
          {/* <Text ont="custom" size="xxs" color="gray" variation="dark">
            thaoliveira@santander.com.br.
          </Text> */}
        </div>
      </ModalFeedback>
    </>
  )
}

RegisterEmailForm.defaultProps = {
  handleSubmit: null
}

RegisterEmailForm.propTypes = {
  handleSubmit: PropTypes.func
}

export default RegisterEmailForm
